<template>
  <div class="payment-list-filter">
    <BuildingFilterItem v-bind="$props" />
    <DateFilterItem
      v-bind="$props"
      :name="'transactionDateStart'"
      :label="'Utbetalingsdato fra og med'"
      :placeholder="'Velg dato'"
    />
    <DateFilterItem
      v-bind="$props"
      :name="'transactionDateEnd'"
      :label="'Utbetalingsdato til og med'"
      :placeholder="'Velg dato'"
      :error="transactionDateEndError"
    />
  </div>
</template>

<script>
import FilterMixin from '@/components/reports/filters/FilterMixin';
import BuildingFilterItem from '@/components/reports/filters/items/BuildingFilterItem';
import DateFilterItem from '@/components/reports/filters/items/DateFilterItem';
import { mapState } from 'vuex';

export default {
  name: 'PaymentFilter',

  mixins: [FilterMixin],

  data() {
    return {
      transactionDateEndError: null,
    };
  },

  computed: {
    ...mapState('reports', {
      data: state => state.reportData,
      transactionDateStart: state =>
        state.localFilters && state.localFilters.paymentList
          ? state.localFilters.paymentList.transactionDateStart
          : null,
      transactionDateEnd: state =>
        state.localFilters && state.localFilters.paymentList ? state.localFilters.paymentList.transactionDateEnd : null,
    }),
  },

  watch: {
    transactionDateStart: {
      handler() {
        this.checkStartEndDate(this.transactionDateStart, this.transactionDateEnd);
      },
    },
    transactionDateEnd: {
      handler() {
        this.checkStartEndDate(this.transactionDateStart, this.transactionDateEnd);
      },
    },
  },

  methods: {
    checkStartEndDate(startDate, endDate) {
      if (startDate && endDate && endDate < startDate) {
        this.transactionDateEndError = 'dato opp til før dato fra';
      } else {
        this.transactionDateEndError = null;
      }
    },
  },

  components: {
    BuildingFilterItem,
    DateFilterItem,
  },
};
</script>

<style scoped lang="scss">
.payment-list-filter {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); // breaks at about 1240
  grid-gap: 1.25rem;
}
</style>
